import moment from 'moment'
import { TimelineData } from '../context/DataContext'

export type RestSpan = { s: number; e: number; len: number }

export type RestLaneResolver = {
  restLaneFor: (start: any, end: any) => number
  restIsTop: (start: any, end: any) => boolean
}

export const toMs = (t: any): number => {
  const m = moment(t)
  return m.isValid() ? m.valueOf() : NaN
}

export function buildRestSpans(data: TimelineData): RestSpan[] {
  const spans: RestSpan[] = []
  const push = (start: any, end: any) => {
    const s = toMs(start)
    const e = toMs(end)
    if (!isNaN(s) && !isNaN(e) && e > s) spans.push({ s, e, len: e - s })
  }

  ;(data.breaks || []).forEach((b: any) => push(b.startTime, b.formalRestEndDate))
  ;(data.partialBreaks || []).forEach((b: any) => {
    if (b.startTime && b.endTime) {
      push(b.startTime, b.endTime)
    } else {
      push(b.startTime, b.firstPartRestEndTime)
      push(b.secondPartBreakStartTime, b.formalRestEndDate)
    }
  })
  ;(data.dailyRests || []).forEach((d: any) => push(d.startTime, d.realRestEndTime))
  ;(data.dailyPartialRegularRests || []).forEach((d: any) => {
    push(d.startTime, d.firstPartRestEndTime)
    push(d.secondPartRestStartTime, d.formalRestEndDate)
  })
  ;(data.weeklyRests || []).forEach((w: any) =>
    push(w.startTime, w.endTime ?? w.realRestEndTime),
  )
  ;(data.weeklyReducedRests || []).forEach((w: any) =>
    push(w.startTime, w.endTime),
  )

  return spans
}

export function createRestLaneResolver(
  spans: ReadonlyArray<RestSpan>,
): RestLaneResolver {
  const restLaneFor = (start: any, end: any): number => {
    const s = toMs(start)
    const e = toMs(end)
    if (isNaN(s) || isNaN(e)) return 0
    const len = e - s
    let lane = 0
    for (const sp of spans) {
      if (
        sp.e > s &&
        sp.s < e &&
        (sp.len > len || (sp.len === len && sp.s < s))
      ) {
        lane++
      }
    }
    return lane
  }

  const restIsTop = (start: any, end: any): boolean => {
    const s = toMs(start)
    const e = toMs(end)
    if (isNaN(s) || isNaN(e)) return true
    const len = e - s
    for (const sp of spans) {
      if (
        sp.e > s &&
        sp.s < e &&
        (sp.len < len || (sp.len === len && sp.s > s))
      ) {
        return false
      }
    }
    return true
  }

  return { restLaneFor, restIsTop }
}
